
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class GiftListToggle extends Vue {
	@Prop() private giftListPanelOpen: boolean;
	@Prop() private isGiftFinderPage: boolean;

	isOpen: boolean = false;
	animated: boolean = false;

	created() {
		this.isOpen = false;
		console.log("$bus", this.$bus);
	}

	computed() {
		this.isOpen = this.giftListPanelOpen;
	}

	mounted() {
		setTimeout(() => {
			this.animated = true;
		}, 100);
	}

	get isAnimated() {
		return this.animated;
	}

	get isMobile() {
		return this.$root.$data.isMobile;
	}

	get isOpenPanel() {
		return this.giftListPanelOpen;
	}

	toggleGiftList() {
		if (this.giftListPanelOpen) {
			this.closeGiftList();
		} else {
			this.openGiftList();
		}
	}

	openGiftList() {
		console.log("open");
		this.isOpen = true;
		this.$emit("open-gift-list");
	}

	closeGiftList() {
		console.log("close");
		this.isOpen = false;
		this.$emit("close-gift-list");
	}

	hideGiftList() {
		console.log("hide");
		this.closeGiftList();
		this.animated = false;
		this.$emit("remove-gift-list");
		window.localStorage.removeItem(this.$root.$data.storageKeyDisplay);
	}
}
